export default "<p>datepicker-decade works!</p>\n";